/**
 * Wire contract for the admin inspectors LIST surface (AUT-114 /
 * PHASE-B-API-3):
 *
 *   - `GET /admin/inspectors` → `ListAdminInspectorsResultDto`
 *
 * Centralised in `@carcheck/shared` so the api + admin SPA import the
 * same source of truth — no api↔admin mirror drift.
 *
 * PII discipline (architect lock — AUT-114): the `name` / `phone` /
 * `email` fields carry REDACTED values (`+375••••••67`, `i••@••.com`,
 * `И. Д••`) when the calling admin lacks the `view_pii` permission.
 * The `piiRevealed` flag tells the SPA which variant it received so it
 * never re-redacts a full value or renders a redacted value as
 * copyable. The server is the sole authority on redaction —
 * `verify_inspectors` is the ACCESS gate (admin must hold it to read
 * the surface at all), `view_pii` is the additional REVEAL gate.
 *
 * All `Date` fields are ISO-8601 strings (JSON has no `Date`); consumers
 * convert at the render boundary via `new Date(dto.createdAt)`.
 */
/**
 * Admin-facing inspector FSM status — the FULL 10-state internal
 * lifecycle. Mirror of Prisma `InspectorStatus`; kept here so the SPA
 * avoids `@prisma/client`.
 *
 * Single source of truth for the api's filter Zod schema too — the api
 * imports `ADMIN_INSPECTOR_STATUSES` rather than hand-typing the values.
 */
export const ADMIN_INSPECTOR_STATUSES = [
    'unverified',
    'profile_filled',
    'idcheck_pending',
    'idcheck_passed',
    'idcheck_failed',
    'bank_pending',
    'active',
    'reverification_required',
    'suspended',
    'banned',
];
//# sourceMappingURL=admin-inspector-list.js.map